import React, { useState } from 'react';
import EcoSpace from 'eco-design/base/eco-space';
import EcoTitle from 'eco-design/base/eco-title';
import { useCountDown } from 'ahooks';
import dynamic from 'next/dynamic';
import Dialog from './Dialog';
import style from './index.module.scss';
import { useLang } from '@/i18n';
import EcoLink from 'eco-design/base/eco-link';
import EcoIconArrowButton from 'eco-design-micro/icons/eco-icon-arrow-button';
import getLocal from '@/app/utils/getLocal';
import { useGlobal } from '@/utils/useGlobal';
import gtm from '@/utils/gtm';

interface Props {
    endTime: number;
}

const Countdown = dynamic(() => import('./Countdown'), {
    ssr: false, // 关键点：关闭服务端渲染
});

const EarlyBird: React.FC<Props> = ({ endTime }) => {
    const { getSystemTime, useRouter } = useGlobal();
    const router = useRouter();
    const { t } = useLang('powerBank.EarlyBird');
    const { locale = 'us' } = getLocal();

    const EU_List = [
        {
            title: t('item1'),
            desc: t('desc1'),
            pc: (() => {
                const img = {
                    en: 'https://websiteoss.ecoflow.com/upload/image/1750400777411/EN.png',
                    es: 'https://websiteoss.ecoflow.com/upload/image/1750400777228/ES.png',
                    it: 'https://websiteoss.ecoflow.com/upload/image/1750400776858/IT.png',
                    fr: 'https://websiteoss.ecoflow.com/upload/image/1750400777061/FR.png',
                    de: 'https://websiteoss.ecoflow.com/upload/image/1750400776666/DE.png',
                };
                return img[locale as 'en'] || img['en'];
            })(),
        },
        {
            title: t('item2'),
            desc: t('desc2'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1749019824638/2.png',
        },
        {
            title: t('item3'),
            desc: t('desc3'),
            pc: (() => {
                const img = {
                    en: 'https://websiteoss.ecoflow.com/upload/image/1750400870271/EN.png',
                    de: 'https://websiteoss.ecoflow.com/upload/image/1750400869750/DE.png',
                    fr: 'https://websiteoss.ecoflow.com/upload/image/1750400870445/FR.png',
                    it: 'https://websiteoss.ecoflow.com/upload/image/1750400870642/IT.png',
                    es: 'https://websiteoss.ecoflow.com/upload/image/1750400870118/ES.png',
                };
                return img[locale as 'en'] || img['en'];
            })(),
            linkText: t('link3'),
            link: `https://${locale}.ecoflow.com/collections/power-bank?sort_by=best-selling&filter.p.m.custom.filter_series=RAPID+Mag&powerbank-trade-in=true`,
        },
    ];

    // 倒计时
    const [, formattedRes] = useCountDown({ targetDate: endTime });

    // 弹窗
    const [open, setOpen] = useState(false);

    let systemTime = getSystemTime();
    const { _timer } = router.query;
    if (_timer) {
        systemTime = new Date(_timer).getTime();
    }
    if (systemTime >= endTime) return null;

    return (
        <>
            <EcoSpace />
            <div className={`${style.comp} GtmModuleData-module EarlyBird`} data-section-id={'EarlyBird'}>
                <EcoTitle title={t('title')} />
                <Countdown days={formattedRes.days} hours={formattedRes.hours} minutes={formattedRes.minutes} seconds={formattedRes.seconds} />
                <div className="cards">
                    {EU_List.map((i, idx) => (
                        <div className="card-item" key={idx}>
                            <img src={i.pc} alt="" />
                            <div className="card-item-info">
                                <div className="card-item-title">{i.title}</div>
                                <div className="card-item-desc">{i.desc}</div>
                                {i.linkText && (
                                    <EcoLink
                                        className={`card-item-link link-${idx + 1} GtmModuleData-btn-href`}
                                        href={i.link}
                                        dataLayer={{
                                            __btn_id1: `EarlyBird  link-${idx + 1}`,
                                            __btn_id2: i.link,
                                            __btn_type: 'href',
                                        }}
                                    >
                                        {i.linkText}
                                        <EcoIconArrowButton />
                                    </EcoLink>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
                <div
                    className="tc-btn GtmModuleData-btn-text"
                    onClick={() => {
                        gtm.push({
                            __btn_id1: 'EarlyBird .tc-btn',
                            __btn_id2: t('footer'),
                            __btn_type: 'text',
                        });
                        setOpen(true);
                    }}
                >
                    {t('footer')}
                </div>
            </div>

            <Dialog open={open} onClose={() => setOpen(false)} />
        </>
    );
};
export default EarlyBird;
